import {
  HTTP_COUNTRYSPECIAL_FETCHING,
  HTTP_COUNTRYSPECIAL_SUCCESS,
  HTTP_COUNTRYSPECIAL_FAILED,
  server,
} from "././../../Constants";
import { httpClient } from "./../../utils/HttpClient";
//   import { async } from "q";

export const setStateCountrySpecialToFetching = () => ({
  type: HTTP_COUNTRYSPECIAL_FETCHING,
});

export const setStateCountrySpecialToSuccess = (payload) => ({
  type: HTTP_COUNTRYSPECIAL_SUCCESS,
  payload,
});

export const setStateCountrySpecialToFailed = () => ({
  type: HTTP_COUNTRYSPECIAL_FAILED,
});

export const getCountrysSpecial = () => {
  return (dispatch) => {
    dispatch(setStateCountrySpecialToFetching());
    goGetCountrySpecial(dispatch);
  };
};

const goGetCountrySpecial = async (dispatch) => {
  // console.log(server.COUNTRY_URL);

  try {
    const result = await httpClient.get(server.COUNTRYSPECIAL_URL);
    dispatch(setStateCountrySpecialToSuccess(result.data));
  } catch (error) {
    dispatch(setStateCountrySpecialToFailed());
  }
};
